package ru.education.building.schedule.view.viewmodels

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import ru.education.building.schedule.data.repositories.ScheduleRepository
import ru.education.building.schedule.view.states.UiState


class ScheduleViewModel(private val repo: ScheduleRepository): ViewModel() {
    private val _state = MutableStateFlow<UiState>(UiState.Loading)
    val state: StateFlow<UiState> = _state.asStateFlow()

    init {
        if (repo.selectedGroup != null && repo.selectedId != null) {
            viewModelScope.launch(Dispatchers.Default) {
                try {
                    val data = repo.loadSchedule(repo.selectedId!!)
                    if (repo.cachedSchedule.hashCode() != data.hashCode()) {
                        repo.selectSchedule(data)
                    }
                } catch (e: Exception) {
                    _state.value = UiState.Error(e.message ?: "Error")
                }
            }
        }
    }

    fun load(id: String) {
        viewModelScope.launch {
            _state.value = UiState.Loading
            try {
                val data = repo.loadSchedule(id)
                _state.value = UiState.Data(data)
            } catch (e: Exception) {
                _state.value = UiState.Error(e.message ?: "Error")
            }
        }
    }

    fun loadGroup() {
        viewModelScope.launch {
            _state.value = UiState.Loading
            try {
                val data = repo.loadGroup()
                _state.value = UiState.Group(data)
            } catch (e: Exception) {
                _state.value = UiState.Error(e.message ?: "Error")
            }
        }
    }

    // onDispose/onCleared не нужны — viewModelScope автоматически отменяется
}